(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-abertura"]) return;
  try {
    
class VXAberturaSlogan extends HTMLElement {
  connectedCallback() {
    const umaVez = this.dataset.umaVez === 'true';
    const chave = 'vx-abertura-vista-slogan-v1';
    const noEditor = window.Shopify && window.Shopify.designMode;
    const navegacao = typeof performance.getEntriesByType === 'function'
      ? performance.getEntriesByType('navigation')[0]
      : null;
    const recarregou = navegacao
      ? navegacao.type === 'reload'
      : Boolean(performance.navigation && performance.navigation.type === 1);

    if (umaVez && !noEditor) {
      let jaViu = false;
      try { jaViu = sessionStorage.getItem(chave) === 'sim'; } catch (erro) { jaViu = false; }

      if (jaViu && !recarregou) {
        this.classList.add('ja-passou');
        document.documentElement.classList.add('vx-abertura-ja-vista');
        return;
      }

      /* A marca so e gravada ao terminar, nao ao comecar: quem
         fechar a aba no meio ve a sequencia inteira na proxima vez. */
      this.chave = chave;
    }

    document.body.classList.add('vx-abertura-ativa');

    if (this.dataset.modo === 'video') this.montarVideo();
    else this.montarAnimacao();
  }

  montarAnimacao() {
    const total = parseInt(this.dataset.total, 10) || 3800;
    this.minimo = parseInt(this.dataset.minimo, 10) || 2500;
    this.nascimento = performance.now();

    this.timer = setTimeout(() => this.encerrar(), total + 140);
    this.ouvirGestos();
  }

  /* ============================================================
     MODO VIDEO

     Escolhe o arquivo pela largura da tela e apaga o outro, para o
     navegador nao baixar os dois. Se so um dos dois estiver
     preenchido, ele vale para as duas telas.

     Redes de seguranca, porque video em navegador falha de varias
     formas: recusa de tocar sozinho, arquivo que nao carrega, ou
     um filme que trava. Em qualquer uma delas a abertura encerra
     em vez de deixar a pessoa presa numa tela parada.
     ============================================================ */
  montarVideo() {
    const saida = parseInt(this.dataset.videoSaida, 10) || 600;
    const limite = parseInt(this.dataset.videoLimite, 10) || 0;

    this.nascimento = performance.now();
    this.minimo = this.dataset.pularLivre === 'true' ? 0 : 900;

    const pular = this.querySelector('[data-vx-pular]');
    if (pular) pular.addEventListener('click', () => this.encerrar(saida));

    const todos = Array.from(this.querySelectorAll('[data-vx-video]'));
    if (!todos.length) { this.encerrar(saida); return; }

    const estreito = window.matchMedia('(max-width: 749px)').matches;
    const desejado = estreito ? 'mobile' : 'desktop';

    let video = todos.find((v) => v.dataset.tela === desejado) || todos[0];

    todos.forEach((v) => { if (v !== video) v.remove(); });

    video.addEventListener('ended', () => this.encerrar(saida));
    video.addEventListener('error', () => this.encerrar(0));

    /* Erro na fonte nao sobe ate o <video>, entao a fonte avisa.

       ATENCAO: so a ULTIMA fonte pode encerrar a abertura. O navegador
       testa as fontes em ordem e dispara erro em cada uma que nao
       consegue tocar, mesmo quando a seguinte funciona. Antes todas
       avisavam: num navegador que nao toca o formato da primeira
       fonte, a abertura fechava em poucos milissegundos e o video
       nunca aparecia. Nao volte a ouvir todas as fontes. */
    const fontes = video.querySelectorAll('source');
    const ultima = fontes[fontes.length - 1];
    if (ultima) ultima.addEventListener('error', () => this.encerrar(0));

    if (limite > 0) {
      this.timer = setTimeout(() => this.encerrar(saida), limite);
    }

    /* preload="none" no HTML evita baixar os dois arquivos antes da
       escolha. Aqui o escolhido e liberado para carregar e tocar. */
    video.preload = 'auto';
    video.load();

    const tentativa = video.play();
    if (tentativa && typeof tentativa.catch === 'function') {
      tentativa.catch(() => this.encerrar(0));
    }

    this.ouvirGestos(saida);
  }

  ouvirGestos(saida) {
    ['click', 'wheel', 'touchstart', 'keydown'].forEach((evento) => {
      window.addEventListener(evento, () => {
        if (performance.now() - this.nascimento < this.minimo) return;
        this.encerrar(saida);
      }, { passive: true });
    });
  }

  encerrar(saida) {
    if (this.encerrada) return;
    this.encerrada = true;
    clearTimeout(this.timer);

    const fechar = () => {
      if (this.chave) {
        try { sessionStorage.setItem(this.chave, 'sim'); } catch (erro) { /* silencioso */ }
        document.documentElement.classList.add('vx-abertura-ja-vista');
      }

      this.classList.add('terminou');
      document.body.classList.remove('vx-abertura-ativa');
    };

    if (saida && saida > 0 && this.dataset.modo === 'video') {
      this.classList.add('esta-saindo');
      setTimeout(fechar, saida);
    } else {
      fechar();
    }
  }
}

if (!customElements.get('vx-abertura-slogan')) {
  customElements.define('vx-abertura-slogan', VXAberturaSlogan);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-carrinho"] && !Shopify.designMode) return;
  try {
    
class VXCarrinho extends HTMLElement {
  connectedCallback() {
    this.montar();
  }

  /* Chamado na entrada e de novo a cada redesenho, porque os
     elementos sao substituidos e os antigos levam junto os seus
     ouvintes de clique. */
  montar() {
    this.querySelectorAll('[data-vx-item]').forEach((item) => this.montarItem(item));
    this.montarCupom();
  }

  montarItem(item) {
    const linha = item.dataset.linha;
    const campo = item.querySelector('[data-vx-qtd]');
    const menos = item.querySelector('[data-vx-menos]');
    const mais = item.querySelector('[data-vx-mais]');
    const remover = item.querySelector('[data-vx-remover]');

    if (menos) menos.addEventListener('click', () => {
      const novo = Math.max(0, (parseInt(campo.value, 10) || 1) - 1);
      this.atualizar(item, linha, novo);
    });

    if (mais) mais.addEventListener('click', () => {
      this.atualizar(item, linha, (parseInt(campo.value, 10) || 1) + 1);
    });

    if (campo) campo.addEventListener('change', () => {
      this.atualizar(item, linha, Math.max(0, parseInt(campo.value, 10) || 0));
    });

    if (remover) remover.addEventListener('click', () => this.atualizar(item, linha, 0));
  }

  /* ============================================================
     ATUALIZAR SEM RECARREGAR

     Antes a pagina era recarregada a cada mudanca. Funcionava, mas
     um recarregamento e uma visita nova: a abertura do site podia
     rodar de novo, a tela piscava e a pessoa perdia a posicao da
     rolagem.

     Agora o proprio Shopify e quem redesenha: pedimos so esta
     secao de volta, ja com os numeros novos, e trocamos o conteudo
     na tela. O resto da pagina nem sabe que algo mudou.
     ============================================================ */

  async atualizar(item, linha, quantidade) {
    const removendo = quantidade === 0;
    item.classList.add('esta-ocupado');

    try {
      const resposta = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(linha, 10), quantity: quantidade })
      });
      if (!resposta.ok) throw new Error('falhou');

      if (removendo) {
        item.classList.add('esta-saindo');
        await new Promise((r) => setTimeout(r, 200));
      }

      await this.redesenhar();

      /* O cabecalho ja se atualiza sozinho ao ver o pedido sair,
         mas o aviso garante o caso de ele ter sido montado depois. */
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (erro) {
      item.classList.remove('esta-ocupado');
      item.classList.remove('esta-saindo');
    }
  }

  async redesenhar() {
    const secao = this.dataset.secao;
    const url = window.location.pathname + '?section_id=' + encodeURIComponent(secao);

    const resposta = await fetch(url, { cache: 'no-store' });
    if (!resposta.ok) throw new Error('nao veio');

    const texto = await resposta.text();
    const novo = new DOMParser()
      .parseFromString(texto, 'text/html')
      .querySelector('vx-carrinho');

    if (!novo) throw new Error('sem secao');

    this.innerHTML = novo.innerHTML;
    this.montar();
  }

  /* O Shopify aplica cupom pela rota /discount/CODIGO, que grava o
     desconto na sessao e redireciona de volta. */
  montarCupom() {
    const campo = this.querySelector('[data-vx-cupom]');
    const botao = this.querySelector('[data-vx-aplicar]');
    if (!campo || !botao) return;

    const aplicar = () => {
      const codigo = campo.value.trim();
      if (!codigo) { campo.focus(); return; }

      botao.disabled = true;
      const destino = window.location.pathname + window.location.search;
      window.location.href = '/discount/' + encodeURIComponent(codigo)
        + '?redirect=' + encodeURIComponent(destino);
    };

    botao.addEventListener('click', aplicar);
    campo.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); aplicar(); }
    });
  }
}
if (!customElements.get('vx-carrinho')) customElements.define('vx-carrinho', VXCarrinho);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-carrossel-produtos"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   CARROSSEL DE PRODUTOS

   A fileira nao usa a rolagem do navegador: ela e uma "fita" que o
   JavaScript empurra para o lado. Assim da para:

   - Arrastar com o mouse ou o dedo de forma suave. Ao soltar, a fita
     continua um pouco no embalo (quanto mais rapido o gesto, mais
     longe ela vai) e para encaixada num card.
   - Ser infinita: a fita ganha copias dos cards antes e depois. Quando
     a pessoa passa do ultimo, ja aparece o primeiro de novo, sem fim
     e sem "pulo" visivel. As copias ficam escondidas para leitores de
     tela e fora do Tab do teclado.
   - Setas (quando ligadas), trackpad (deslizar dois dedos para o
     lado) e "Passar sozinho" usam o mesmo movimento suave.
   - No celular, deslizar para cima e para baixo continua rolando a
     pagina; o movimento para o lado (mesmo meio torto) mexe no
     carrossel, e uma passada curta ja leva ao proximo produto.
   - No editor do Shopify, clicar num bloco de produto leva a fita
     ate ele.

   Sem JavaScript, a fileira continua rolavel do jeito comum.
   ============================================================ */
class VXCarrosselTrilho extends HTMLElement {
  connectedCallback() {
    this.trilho = this.querySelector('[data-vx-trilho]');
    this.fita = this.querySelector('[data-vx-fita]');
    if (!this.trilho || !this.fita) return;
    this.originais = Array.from(this.fita.querySelectorAll('[data-vx-card]'));
    if (!this.originais.length) return;

    this.infinito = this.hasAttribute('data-infinito');
    this.copias = 0;
    this.pos = 0;
    this.animando = false;

    this.trilho.classList.add('esta-pronto');
    this.trilho.scrollLeft = 0;

    this.medir();
    const inicial = Math.max(parseInt(this.dataset.inicial, 10) || 1, 1);
    this.pos = this.limitar((Math.min(inicial, this.originais.length) - 1) * this.passo);
    this.desenhar();

    const anterior = this.querySelector('[data-vx-anterior]');
    const proxima = this.querySelector('[data-vx-proxima]');
    if (anterior) anterior.addEventListener('click', () => this.passar(-1));
    if (proxima) proxima.addEventListener('click', () => this.passar(1));

    this.ligarArraste();
    this.ligarRoda();
    this.ligarAutoplay();

    if ('ResizeObserver' in window) {
      this.observador = new ResizeObserver(() => this.aoRedimensionar());
      this.observador.observe(this.trilho);
    }

    this.aoSelecionarBloco = (evento) => {
      const j = this.originais.findIndex((card) => card.dataset.bloco === evento.detail.blockId);
      if (j < 0) return;
      let alvo = j * this.passo;
      if (this.infinito) alvo += Math.round((this.pos - alvo) / this.larguraConjunto) * this.larguraConjunto;
      this.animarPara(this.limitar(alvo));
    };
    document.addEventListener('shopify:block:select', this.aoSelecionarBloco);
  }

  disconnectedCallback() {
    clearInterval(this.relogio);
    cancelAnimationFrame(this.quadro);
    if (this.observador) this.observador.disconnect();
    document.removeEventListener('shopify:block:select', this.aoSelecionarBloco);
  }

  /* ---------- medidas e desenho ---------- */

  medir() {
    const espaco = parseFloat(getComputedStyle(this.fita).columnGap) || 0;
    this.passo = this.originais[0].offsetWidth + espaco;
    this.larguraConjunto = this.passo * this.originais.length;
    if (this.infinito) this.montarCopias();
  }

  /* Copias suficientes para cobrir a tela dos dois lados. */
  montarCopias() {
    const precisa = Math.max(1, Math.ceil(this.trilho.clientWidth / this.larguraConjunto));
    if (precisa === this.copias) return;
    this.fita.querySelectorAll('[data-vx-clone]').forEach((copia) => copia.remove());
    const antes = document.createDocumentFragment();
    const depois = document.createDocumentFragment();
    for (let c = 0; c < precisa; c++) {
      this.originais.forEach((card) => antes.appendChild(this.copiar(card)));
      this.originais.forEach((card) => depois.appendChild(this.copiar(card)));
    }
    this.fita.insertBefore(antes, this.fita.firstChild);
    this.fita.appendChild(depois);
    this.copias = precisa;
  }

  copiar(card) {
    const copia = card.cloneNode(true);
    copia.setAttribute('data-vx-clone', '');
    copia.setAttribute('aria-hidden', 'true');
    copia.removeAttribute('data-bloco');
    copia.removeAttribute('data-shopify-editor-block');
    copia.setAttribute('tabindex', '-1');
    copia.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
    return copia;
  }

  visiveis() {
    const celular = window.matchMedia('(max-width: 749px)').matches;
    return parseInt(celular ? this.dataset.visiveisMobile : this.dataset.visiveis, 10) || 1;
  }

  /* No modo com fim, nao deixa passar do primeiro nem do ultimo. */
  limitar(p) {
    if (this.infinito) return p;
    const maximo = Math.max(0, (this.originais.length - this.visiveis()) * this.passo);
    return Math.min(Math.max(p, 0), maximo);
  }

  encaixar(p) {
    return Math.round(p / this.passo) * this.passo;
  }

  desenhar() {
    let x = this.pos;
    if (this.infinito) {
      const w = this.larguraConjunto;
      x = ((x % w) + w) % w + this.copias * w;
    }
    this.fita.style.transform = 'translate3d(' + (-x) + 'px, 0, 0)';
  }

  /* ---------- movimento ---------- */

  animarPara(alvo, duracao) {
    cancelAnimationFrame(this.quadro);
    const inicio = this.pos;
    const distancia = alvo - inicio;
    this.destino = alvo;
    if (Math.abs(distancia) < 0.5) {
      this.pos = alvo;
      this.animando = false;
      this.desenhar();
      return;
    }
    const tempo = duracao || Math.min(850, 380 + (Math.abs(distancia) / this.passo) * 140);
    const comeco = performance.now();
    this.animando = true;
    const quadro = (agora) => {
      const t = Math.min(1, (agora - comeco) / tempo);
      const suave = 1 - Math.pow(1 - t, 4);
      this.pos = inicio + distancia * suave;
      this.desenhar();
      if (t < 1) {
        this.quadro = requestAnimationFrame(quadro);
      } else {
        this.animando = false;
        /* Mantem o numero pequeno; na tela nada muda. */
        if (this.infinito) this.pos = ((this.pos % this.larguraConjunto) + this.larguraConjunto) % this.larguraConjunto;
      }
    };
    this.quadro = requestAnimationFrame(quadro);
  }

  passar(direcao) {
    const base = this.animando ? this.destino : this.encaixar(this.pos);
    let alvo = base + direcao * this.passo;
    if (!this.infinito) {
      const maximo = this.limitar(Infinity);
      if (alvo > maximo + 1) alvo = 0;
      else if (alvo < -1) alvo = maximo;
    }
    this.animarPara(alvo);
  }

  /* ARRASTE
     Mouse (e caneta) usam os eventos de ponteiro. O dedo usa os
     eventos de toque, que no celular sao os mais confiaveis: assim
     que o dedo anda mais para o lado do que para cima, o carrossel
     "pega" o gesto e trava a rolagem da pagina so durante ele. Se o
     dedo anda mais para cima ou para baixo, a pagina rola normal. */
  ligarArraste() {
    const trilho = this.trilho;
    const estado = { ativo: false, decidido: false, moveu: false, x0: 0, y0: 0, pos0: 0, amostras: [] };

    const iniciar = (x, y, ehMouse) => {
      estado.ativo = true;
      estado.decidido = ehMouse;
      estado.moveu = false;
      estado.x0 = x;
      estado.y0 = y;
      cancelAnimationFrame(this.quadro);
      this.animando = false;
      estado.pos0 = this.pos;
      estado.amostras = [{ x: x, t: performance.now() }];
      this.segurando = true;
    };

    /* Devolve true quando o gesto e do carrossel. */
    const mover = (x, y) => {
      if (!estado.ativo) return false;
      const dx = x - estado.x0;
      const dy = y - estado.y0;
      if (!estado.decidido) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return false;
        estado.decidido = true;
        /* Diagonal tambem conta como lado: polegar raramente anda reto. */
        if (Math.abs(dx) < Math.abs(dy) * 0.8) {
          estado.ativo = false;
          this.segurando = false;
          return false;
        }
      }
      if (!estado.moveu) {
        if (Math.abs(dx) < 4) return true;
        estado.moveu = true;
        trilho.classList.add('esta-arrastando');
      }

      let p = estado.pos0 - dx;
      if (!this.infinito) {
        /* Nas pontas, a fita resiste um pouco em vez de travar seco. */
        const limite = this.limitar(p);
        p = limite + (p - limite) * 0.35;
      }
      this.pos = p;
      this.desenhar();

      const agora = performance.now();
      estado.amostras.push({ x: x, t: agora });
      while (estado.amostras.length > 2 && agora - estado.amostras[0].t > 100) estado.amostras.shift();
      return true;
    };

    const terminar = () => {
      if (!estado.ativo) return;
      estado.ativo = false;
      this.segurando = false;
      trilho.classList.remove('esta-arrastando');
      if (!estado.moveu) return;

      let velocidade = 0;
      const amostras = estado.amostras;
      const ultima = amostras[amostras.length - 1];
      if (amostras.length > 1 && performance.now() - ultima.t < 80) {
        const primeira = amostras[0];
        const dt = ultima.t - primeira.t;
        if (dt > 0) velocidade = (ultima.x - primeira.x) / dt;
      }

      /* Embalo: o gesto rapido leva a fita mais longe (ate 3 cards). */
      let embalo = -velocidade * 220;
      embalo = Math.max(-3 * this.passo, Math.min(3 * this.passo, embalo));
      const partida = this.encaixar(estado.pos0);
      let alvo = this.encaixar(this.pos + embalo);

      /* Um gesto curto ou uma "pincelada" rapida ja passa um produto,
         em vez de voltar para o mesmo lugar. */
      const andou = this.pos - estado.pos0;
      if (alvo === partida && (Math.abs(andou) > this.passo * 0.12 || Math.abs(velocidade) > 0.25)) {
        const direcao = Math.abs(velocidade) > 0.25 ? -Math.sign(velocidade) : Math.sign(andou);
        alvo = partida + direcao * this.passo;
      }
      this.animarPara(this.limitar(alvo));
    };

    /* Mouse e caneta */
    trilho.addEventListener('pointerdown', (evento) => {
      if (evento.pointerType === 'touch' || evento.button !== 0) return;
      iniciar(evento.clientX, evento.clientY, true);
    });
    trilho.addEventListener('pointermove', (evento) => {
      if (evento.pointerType === 'touch' || !estado.ativo) return;
      if (mover(evento.clientX, evento.clientY) && estado.moveu && !trilho.hasPointerCapture(evento.pointerId)) {
        try { trilho.setPointerCapture(evento.pointerId); } catch (erro) { /* sem captura, segue igual */ }
      }
    });
    const soltarPonteiro = (evento) => {
      if (evento.pointerType === 'touch') return;
      terminar();
    };
    trilho.addEventListener('pointerup', soltarPonteiro);
    trilho.addEventListener('pointercancel', soltarPonteiro);
    trilho.addEventListener('lostpointercapture', soltarPonteiro);

    /* Dedo */
    trilho.addEventListener('touchstart', (evento) => {
      if (evento.touches.length !== 1) return;
      const toque = evento.touches[0];
      iniciar(toque.clientX, toque.clientY, false);
    }, { passive: true });
    trilho.addEventListener('touchmove', (evento) => {
      if (!estado.ativo || !evento.touches.length) return;
      const toque = evento.touches[0];
      if (mover(toque.clientX, toque.clientY) && evento.cancelable) evento.preventDefault();
    }, { passive: false });
    trilho.addEventListener('touchend', terminar);
    trilho.addEventListener('touchcancel', terminar);

    /* Depois de arrastar, o clique nao abre o produto sem querer. */
    trilho.addEventListener('click', (evento) => {
      if (estado.moveu) {
        evento.preventDefault();
        evento.stopPropagation();
        estado.moveu = false;
      }
    }, true);

    /* Impede o navegador de "pegar" o link ou a foto para arrastar. */
    trilho.addEventListener('dragstart', (evento) => evento.preventDefault());
  }

  /* Trackpad: deslizar dois dedos para o lado mexe na fita. */
  ligarRoda() {
    this.trilho.addEventListener('wheel', (evento) => {
      if (Math.abs(evento.deltaX) <= Math.abs(evento.deltaY)) return;
      evento.preventDefault();
      cancelAnimationFrame(this.quadro);
      this.animando = false;
      this.pos = this.limitar(this.pos + evento.deltaX);
      this.desenhar();
      clearTimeout(this.esperaRoda);
      this.esperaRoda = setTimeout(() => this.animarPara(this.limitar(this.encaixar(this.pos))), 140);
    }, { passive: false });
  }

  ligarAutoplay() {
    const segundos = parseFloat(this.dataset.autoplay);
    if (!segundos) return;
    let mouseEmCima = false;
    this.addEventListener('mouseenter', () => { mouseEmCima = true; });
    this.addEventListener('mouseleave', () => { mouseEmCima = false; });
    this.relogio = setInterval(() => {
      if (mouseEmCima || this.segurando || document.hidden) return;
      this.passar(1);
    }, segundos * 1000);
  }

  aoRedimensionar() {
    if (!this.passo) return;
    const indice = Math.round(this.pos / this.passo);
    cancelAnimationFrame(this.quadro);
    this.animando = false;
    this.medir();
    this.pos = this.limitar(indice * this.passo);
    this.desenhar();
  }
}
if (!customElements.get('vx-carrossel-trilho')) customElements.define('vx-carrossel-trilho', VXCarrosselTrilho);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-grade-produtos"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   SORTEIO DAS GRADES AUTOMATICAS

   A pagina chega com todos os produtos possiveis e aqui se escolhe
   quais ficam. Ordem de preferencia:
   1. produtos que a pessoa ainda nao abriu neste aparelho;
   2. depois, os que ela ja viu.
   Dentro de cada grupo a ordem e sorteada a cada visita.

   Produtos que ja estao no carrinho vao para o fim da fila. So
   aparecem se nao houver outros suficientes, para a grade nunca
   ficar vazia.

   A memoria de "ja viu" fica so no navegador da pessoa (nada vai
   para o servidor) e guarda os ultimos 30 produtos abertos.
   ============================================================ */
class VXGradeSorteio extends HTMLElement {
  connectedCallback() {
    if (this.montado) return;
    this.montado = true;

    this.quantidade = parseInt(this.dataset.quantidade, 10) || 3;
    this.cards = Array.from(this.querySelectorAll('[data-vx-sorteio-card]'));
    if (!this.cards.length) return;

    const vistos = this.lerVistos();
    this.registrarVisita(vistos);

    const embaralhar = (lista) => {
      for (let i = lista.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [lista[i], lista[j]] = [lista[j], lista[i]];
      }
      return lista;
    };
    const naoVistos = embaralhar(this.cards.filter((c) => !vistos.includes(c.dataset.handle)));
    const jaVistos = embaralhar(this.cards.filter((c) => vistos.includes(c.dataset.handle)));
    this.ordem = naoVistos.concat(jaVistos);

    this.mostrar([]);
    this.conferirCarrinho();
  }

  lerVistos() {
    try {
      const lista = JSON.parse(localStorage.getItem('vx_vistos') || '[]');
      return Array.isArray(lista) ? lista : [];
    } catch (erro) {
      return [];
    }
  }

  /* Na pagina de produto, anota que a pessoa abriu este produto. */
  registrarVisita(vistos) {
    const atual = this.dataset.atualHandle;
    if (!atual) return;
    const nova = [atual].concat(vistos.filter((h) => h !== atual)).slice(0, 30);
    try { localStorage.setItem('vx_vistos', JSON.stringify(nova)); } catch (erro) { /* silencioso */ }
  }

  /* Os cards que nao entram saem da pagina (e nao so escondidos):
     assim a regra do celular que estica o ultimo card impar para a
     largura toda continua acertando o card certo. */
  mostrar(noCarrinho) {
    const fora = this.ordem.filter((c) => !noCarrinho.includes(c.dataset.id));
    const dentro = this.ordem.filter((c) => noCarrinho.includes(c.dataset.id));
    const escolhidos = fora.concat(dentro).slice(0, this.quantidade);

    this.cards.forEach((c) => { if (!escolhidos.includes(c)) c.remove(); });
    escolhidos.forEach((c) => this.appendChild(c));
    this.classList.add('esta-pronto');
  }

  conferirCarrinho() {
    fetch('/cart.js', { cache: 'no-store' })
      .then((resposta) => resposta.json())
      .then((carrinho) => {
        const ids = (carrinho.items || []).map((item) => String(item.product_id));
        if (ids.length) this.mostrar(ids);
      })
      .catch(() => { /* silencioso: fica o primeiro sorteio */ });
  }
}
if (!customElements.get('vx-grade-sorteio')) customElements.define('vx-grade-sorteio', VXGradeSorteio);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-header"]) return;
  try {
    
class VXHeader extends HTMLElement {
  connectedCallback() {
    this.pilula = this.querySelector('[data-vx-pilula]');
    this.gaveta = this.querySelector('.vx-header__gaveta');

    this.montarMenuMobile();
    this.montarCarrinho();
    this.montarComportamento();

    if (this.dataset.adaptar === 'true') this.montarAdaptacao();
  }

  disconnectedCallback() {
    if (Array.isArray(this.limparAdaptacao)) {
      this.limparAdaptacao.forEach((fn) => fn());
      this.limparAdaptacao = [];
    }
    if (Array.isArray(this.limpar)) {
      this.limpar.forEach((fn) => fn());
      this.limpar = [];
    }
    if (this.observadorSecao) this.observadorSecao.disconnect();
    if (this.quadro) cancelAnimationFrame(this.quadro);
    if (this.timerAbertura) clearTimeout(this.timerAbertura);
  }

  montarMenuMobile() {
    const botao = this.querySelector('.vx-header__hamburguer');
    if (!botao || !this.gaveta) return;

    botao.addEventListener('click', () => {
      const aberto = botao.getAttribute('aria-expanded') === 'true';
      botao.setAttribute('aria-expanded', String(!aberto));
      this.gaveta.hidden = aberto;
      this.decidir();
    });
  }

  /* ============================================================
     CONTADOR DO CARRINHO

     Antes o numero so mudava quando alguem avisava por um evento.
     Se o aviso nao chegasse — codigo de outra secao, app externo,
     botao do proprio tema — o contador ficava parado e a pessoa
     nao via que o produto entrou.

     Agora o cabecalho descobre sozinho: qualquer pedido enviado
     para um endereco do carrinho faz o contador se conferir logo
     depois. Nao depende de aviso nenhum, entao vale para todos os
     botoes do site, inclusive os que ainda nao existem.
     ============================================================ */

  montarCarrinho() {
    this.contador = this.querySelector('[data-vx-cart-count]');
    if (!this.contador) return;

    ['cart:refresh', 'cart:update', 'cart:change'].forEach((evento) => {
      document.addEventListener(evento, () => this.atualizarContador());
    });

    this.espionarPedidos();

    /* Voltar pelo botao do navegador entrega a pagina do cache, com
       o numero antigo. Aqui ele e conferido de novo. */
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) this.atualizarContador();
    });
  }

  espionarPedidos() {
    if (window.__vxCarrinhoEspiao) return;
    window.__vxCarrinhoEspiao = true;

    const originalFetch = window.fetch;
    if (typeof originalFetch !== 'function') return;

    const mexeNoCarrinho = (entrada) => {
      let url = '';
      if (typeof entrada === 'string') url = entrada;
      else if (entrada && entrada.url) url = entrada.url;
      return /\/cart\/(add|change|update|clear)/.test(url);
    };

    window.fetch = function (...args) {
      const resultado = originalFetch.apply(this, args);

      if (mexeNoCarrinho(args[0])) {
        resultado.then(() => {
          document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
        }).catch(() => { /* silencioso */ });
      }

      return resultado;
    };
  }

  async atualizarContador() {
    if (!this.contador) return;

    try {
      const resposta = await fetch('/cart.js', { cache: 'no-store' });
      const carrinho = await resposta.json();
      const antes = parseInt(this.contador.textContent, 10) || 0;

      this.contador.textContent = carrinho.item_count;
      this.contador.hidden = carrinho.item_count === 0;

      if (carrinho.item_count !== antes && carrinho.item_count > 0) {
        this.contador.classList.remove('esta-pulsando');
        void this.contador.offsetWidth;
        this.contador.classList.add('esta-pulsando');
      }
    } catch (erro) { /* silencioso */ }
  }

  /* ============================================================
     COMPORTAMENTO DA PILULA
     ============================================================ */

  montarComportamento() {
    this.auto = this.dataset.auto === '1';
    this.desliza = this.dataset.desliza === '1';
    if (!this.auto && !this.desliza) return;
    if (!this.pilula) return;

    this.referencia = document.getElementById('MainContent')
      || document.querySelector('main')
      || document.body;

    this.limpar = [];
    this.naSecao = false;
    this.descendo = false;
    this.sobreMenu = false;
    this.focoTeclado = false;
    this.tocou = false;
    this.inicioToque = null;
    this.noTopo = true;
    this.estado = null;

    this.limiarTopo = parseFloat(this.dataset.limiarTopo) || 80;
    this.sensib = parseFloat(this.dataset.sensibRolagem) || 6;
    this.recuo = parseFloat(this.dataset.recuo) || 18;
    this.ultimaPos = this.posicao();

    const registrar = (destino, evento, fn, opcoes) => {
      if (!destino) return;
      destino.addEventListener(evento, fn, opcoes);
      this.limpar.push(() => destino.removeEventListener(evento, fn, opcoes));
    };

    /* Modo discreto. Antes, um observador escondia a pilula assim que
       QUALQUER parte da secao do produto aparecesse na tela. Como a
       secao e alta, quem voltava rolando para cima via o menu sumir
       longe do topo, so por encostar no final da secao.

       Agora a referencia e o nome do produto: a pilula so some quando
       o nome esta na tela ou chegando ao topo dela (e ali que ela o
       tamparia). No meio da secao vale a regra normal de rolagem.
       A medida e feita a cada quadro, junto com a rolagem. */
    this.seletorAlvo = this.dataset.autoAlvo || '.vx-pp';
    this.medirSecaoAtivo = this.auto && (this.dataset.autoModo || 'secao') === 'secao';
    this.folgaTitulo = parseFloat(this.dataset.folgaTitulo);
    if (isNaN(this.folgaTitulo)) this.folgaTitulo = 60;
    this.folgaTituloMob = parseFloat(this.dataset.folgaTituloMob);
    if (isNaN(this.folgaTituloMob)) this.folgaTituloMob = 60;
    this.telaCelular = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

    /* Meia pilula. Vale em qualquer tela sem mouse (celular e tablet):
       o problema e nao ter mouse para chamar o menu, nao o tamanho da
       tela. Notebook com tela de toque tem mouse e fica como computador. */
    this.meiaAtiva = this.dataset.meia === '1';
    this.telaToque = window.matchMedia ? window.matchMedia('(hover: none)') : null;
    this.faixa = parseFloat(this.dataset.meiaFaixa);
    if (isNaN(this.faixa)) this.faixa = 30;
    this.espera = parseFloat(this.dataset.meiaEspera);
    if (isNaN(this.espera)) this.espera = 1200;
    this.bloqueioAte = 0;

    /* Abertura: ao entrar na pagina a pilula aparece inteira e, depois
       da espera, recolhe para a meia pilula. Mexer na tela antes disso
       encerra a espera na hora. */
    this.abrindo = this.usarMeia();
    if (this.abrindo) {
      this.timerAbertura = setTimeout(() => {
        this.abrindo = false;
        this.decidir();
      }, this.espera);
    }

    /* Mouse: so conta como "sobre o menu" quando e mouse de verdade.
       No celular o navegador finge um mouse depois de cada toque, mas
       nunca finge a saida dele: a pilula ficava presa, sempre visivel. */
    const eMouse = (e) => e.pointerType !== 'touch';
    const entrar = (e) => { if (eMouse(e)) { this.sobreMenu = true; this.decidir(); } };
    const sair = (e) => { if (eMouse(e)) { this.sobreMenu = false; this.decidir(); } };

    const zona = this.querySelector('[data-vx-zona]');
    registrar(zona, 'pointerenter', entrar);
    registrar(zona, 'pointerleave', sair);
    registrar(this.pilula, 'pointerenter', entrar);
    registrar(this.pilula, 'pointerleave', sair);

    /* Teclado: a pilula fica visivel enquanto o foco de teclado esta
       nela. Foco vindo de toque nao conta: no celular, tocar no botao
       do menu deixava o foco preso nele e a pilula nao sumia mais. */
    const focoDeTeclado = (el) => {
      try { return el.matches(':focus-visible'); } catch (erro) { return true; }
    };
    registrar(this.pilula, 'focusin', (e) => { this.focoTeclado = focoDeTeclado(e.target); this.decidir(); });
    registrar(this.pilula, 'focusout', () => { this.focoTeclado = false; this.decidir(); });

    /* Toque: um toque rapido na area do menu (sem arrastar a tela)
       mostra a pilula. Ela fica ate a proxima rolagem e depois volta
       a seguir as regras normais. Antes o toque marcava "sobre o
       menu" e nada desmarcava: a pilula travava visivel no celular. */
    registrar(this, 'touchstart', () => { this.inicioToque = this.posicao(); }, { passive: true });
    registrar(this, 'touchend', () => {
      if (this.inicioToque === null) return;
      const moveu = Math.abs(this.posicao() - this.inicioToque) >= this.sensib;
      this.inicioToque = null;
      if (!moveu) { this.tocou = true; this.decidir(); }
    }, { passive: true });

    /* Na meia pilula, tocar em qualquer outro lugar da pagina conta
       como "mexer na tela": a pilula aberta volta a se recolher. */
    registrar(document, 'touchstart', (e) => {
      if (!this.usarMeia() || this.contains(e.target)) return;
      this.abrindo = false;
      this.tocou = false;
      this.decidir();
    }, { passive: true });

    /* Tocar na faixa abre a pilula, e logo em seguida o navegador
       entrega o clique no mesmo ponto — onde agora ja existe um icone.
       Sem este bloqueio, abrir o menu podia levar direto ao carrinho.
       Por isso, enquanto a pilula esta recolhida ou acabou de abrir,
       o clique so abre o menu e nao segue para o que esta embaixo. */
    registrar(this, 'click', (e) => {
      const recolhida = this.estado === 'meia';
      if (!recolhida && performance.now() >= this.bloqueioAte) return;
      e.preventDefault();
      e.stopPropagation();
      if (recolhida) { this.tocou = true; this.decidir(); }
    }, true);

    this.naSecao = this.medirSecao();
    this.vigiar();
    this.decidir();
  }

  usarMeia() {
    return !!(this.meiaAtiva && this.auto && this.telaToque && this.telaToque.matches);
  }

  posicao() {
    if (!this.referencia) return 0;
    return -(this.referencia.getBoundingClientRect().top);
  }

  medirSecao() {
    if (!this.medirSecaoAtivo) return false;

    /* O editor do Shopify redesenha secoes ao mexer num controle: se o
       elemento guardado saiu da pagina, procura de novo. */
    if (!this.alvoSecao || !this.alvoSecao.isConnected) {
      this.alvoSecao = document.querySelector(this.seletorAlvo);
      this.marcoSecao = null;
    }
    if (!this.alvoSecao) return false;
    if (!this.marcoSecao || !this.marcoSecao.isConnected) {
      this.marcoSecao = this.alvoSecao.querySelector('.vx-pp__titulo, h1');
    }

    const alturaTela = window.innerHeight || document.documentElement.clientHeight;
    const secao = this.alvoSecao.getBoundingClientRect();
    if (secao.bottom <= 0 || secao.top >= alturaTela) return false;

    const celular = this.telaCelular && this.telaCelular.matches;
    const folga = celular ? this.folgaTituloMob : this.folgaTitulo;

    /* Sem nome encontrado, o comeco da secao serve de referencia. */
    const borda = this.marcoSecao
      ? this.marcoSecao.getBoundingClientRect().bottom
      : secao.top;

    return borda > -folga;
  }

  vigiar() {
    const passo = () => {
      const pos = this.posicao();
      const dif = pos - this.ultimaPos;

      if (Math.abs(dif) >= this.sensib) {
        this.descendo = dif > 0;
        this.ultimaPos = pos;
        this.tocou = false;
        this.abrindo = false;
      }

      this.noTopo = pos <= this.limiarTopo;
      this.naSecao = this.medirSecao();
      this.decidir();

      this.quadro = requestAnimationFrame(passo);
    };

    this.quadro = requestAnimationFrame(passo);
  }

  /* Tres estados possiveis: 'inteira', 'meia' (so nas telas de
     toque) e 'oculta'. */
  decidir() {
    if (!this.auto && !this.desliza) return;

    const gavetaAberta = this.gaveta && !this.gaveta.hidden;
    let estado = 'inteira';

    if (this.usarMeia()) {
      /* Tela de toque: no topo fica a meia pilula; no meio da pagina,
         descendo ela some inteira e subindo ela volta inteira. O nome
         do produto nao entra na conta aqui, so o topo. */
      if (this.noTopo) estado = 'meia';
      else if (this.desliza && this.descendo) estado = 'oculta';

      if (this.abrindo || this.tocou || this.focoTeclado || gavetaAberta) estado = 'inteira';
    } else {
      if (this.auto && this.naSecao) estado = 'oculta';
      else if (this.desliza && this.descendo && !this.noTopo) estado = 'oculta';

      if (this.sobreMenu || this.focoTeclado || this.tocou || gavetaAberta) estado = 'inteira';
    }

    this.aplicar(estado);
  }

  aplicar(estado) {
    if (estado === this.estado) return;
    const anterior = this.estado;
    this.estado = estado;

    const estilo = this.pilula.style;
    this.classList.toggle('esta-oculto', estado === 'oculta');
    this.classList.toggle('esta-meia', estado === 'meia');

    if (estado === 'oculta') {
      estilo.setProperty('transform', 'translateY(calc(-100% - ' + (this.recuo + 16) + 'px))', 'important');
      estilo.setProperty('opacity', '0', 'important');
      estilo.setProperty('pointer-events', 'none', 'important');
    } else if (estado === 'meia') {
      /* Sobe o suficiente para sobrar so a faixa: a base da pilula
         fica a "faixa" pixels do topo da tela. */
      const ajuste = this.faixa - this.recuo;
      const deslocamento = ajuste >= 0 ? ' + ' + ajuste : ' - ' + Math.abs(ajuste);
      estilo.setProperty('transform', 'translateY(calc(-100%' + deslocamento + 'px))', 'important');
      estilo.removeProperty('opacity');
      estilo.removeProperty('pointer-events');
    } else {
      estilo.removeProperty('transform');
      estilo.removeProperty('opacity');
      estilo.removeProperty('pointer-events');
      if (anterior === 'meia') this.bloqueioAte = performance.now() + 450;
    }
  }

  /* ---------- Adaptacao de cor ---------- */

  montarAdaptacao() {
    this.corPilula = this.paraRGB(this.dataset.corPilula) || { r: 47, g: 59, b: 45 };
    this.limite = parseFloat(this.dataset.limite) || 1.6;
    this.aguardando = false;

    if (Array.isArray(this.limparAdaptacao)) {
      this.limparAdaptacao.forEach((fn) => fn());
    }
    this.limparAdaptacao = [];

    const observar = () => this.agendar();
    const registrar = (alvo, evento, opcoes) => {
      if (!alvo || !alvo.addEventListener) return;
      alvo.addEventListener(evento, observar, opcoes);
      this.limparAdaptacao.push(() => alvo.removeEventListener(evento, observar, opcoes));
    };

    registrar(window, 'scroll', { passive: true });
    registrar(window, 'resize', { passive: true });
    registrar(document, 'scroll', { passive: true, capture: true });

    if (window.visualViewport) {
      registrar(window.visualViewport, 'scroll', { passive: true });
      registrar(window.visualViewport, 'resize', { passive: true });
    }

    this.intervaloAdaptacao = setInterval(() => this.agendar(), 180);
    this.limparAdaptacao.push(() => clearInterval(this.intervaloAdaptacao));

    requestAnimationFrame(() => this.avaliar());
    setTimeout(() => this.avaliar(), 120);
    setTimeout(() => this.avaliar(), 400);
    setTimeout(() => this.avaliar(), 900);
  }

  agendar() {
    if (this.aguardando) return;
    this.aguardando = true;
    requestAnimationFrame(() => {
      this.avaliar();
      this.aguardando = false;
    });
  }

  avaliar() {
    if (!this.pilula) return;
    const caixa = this.pilula.getBoundingClientRect();
    const larguraTela = window.innerWidth || document.documentElement.clientWidth;
    const alturaTela = window.innerHeight || document.documentElement.clientHeight;
    const limitar = (valor, min, max) => Math.max(min, Math.min(max, valor));

    const yCentro = limitar(caixa.top + caixa.height / 2, 1, alturaTela - 2);
    const yBase = limitar(caixa.bottom + 2, 1, alturaTela - 2);
    const xCentro = limitar(caixa.left + caixa.width / 2, 1, larguraTela - 2);
    const xEsq = limitar(caixa.left + Math.min(34, caixa.width * 0.18), 1, larguraTela - 2);
    const xDir = limitar(caixa.right - Math.min(34, caixa.width * 0.18), 1, larguraTela - 2);

    const pontos = [
      [xCentro, yCentro],
      [xEsq, yCentro],
      [xDir, yCentro],
      [xCentro, yBase]
    ];

    const leituras = pontos.map(([x, y]) => this.lerFundo(x, y)).filter(Boolean);
    if (!leituras.length) return;

    let votosAlt = 0;
    let votosNormal = 0;

    leituras.forEach((leitura) => {
      if (leitura === 'alternativo') votosAlt += 1;
      else if (leitura === 'normal') votosNormal += 1;
      else if (this.contraste(this.corPilula, leitura) < this.limite) votosAlt += 1;
      else votosNormal += 1;
    });

    this.classList.toggle('tom-alternativo', votosAlt >= votosNormal && votosAlt > 0);
  }

  temMidiaCobrindo(elemento, x, y) {
    const midias = elemento.querySelectorAll(':scope > img, :scope > video, :scope img, :scope video');
    for (const midia of midias) {
      const r = midia.getBoundingClientRect();
      if (r.width < 40 || r.height < 40) continue;
      if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return true;
    }
    return false;
  }

  lerFundo(x, y) {
    const pilha = document.elementsFromPoint(x, y);

    for (const elemento of pilha) {
      if (this.contains(elemento)) continue;
      if (elemento === document.documentElement) break;

      const marca = elemento.closest('[data-vx-tom]');
      if (marca && !this.contains(marca)) {
        const tom = marca.dataset.vxTom;
        if (tom === 'escuro' || tom === 'alternativo') return 'alternativo';
        if (tom === 'claro' || tom === 'normal') return 'normal';
        return tom;
      }

      const etiqueta = elemento.tagName;
      if (etiqueta === 'IMG' || etiqueta === 'VIDEO' || etiqueta === 'PICTURE') return 'normal';

      const estilo = getComputedStyle(elemento);
      if (estilo.backgroundImage && estilo.backgroundImage !== 'none') return 'normal';

      if (this.temMidiaCobrindo(elemento, x, y)) return 'normal';

      const cor = this.paraRGB(estilo.backgroundColor);
      if (cor) return cor;
    }

    return this.paraRGB(getComputedStyle(document.body).backgroundColor);
  }

  paraRGB(valor) {
    if (!valor) return null;

    if (valor.charAt(0) === '#') {
      let hex = valor.slice(1);
      if (hex.length === 3) hex = hex.split('').map((c) => c + c).join('');
      if (hex.length < 6) return null;
      return {
        r: parseInt(hex.slice(0, 2), 16),
        g: parseInt(hex.slice(2, 4), 16),
        b: parseInt(hex.slice(4, 6), 16)
      };
    }

    const partes = valor.match(/[\d.]+/g);
    if (!partes || partes.length < 3) return null;
    if (partes.length > 3 && parseFloat(partes[3]) < 0.35) return null;

    return { r: +partes[0], g: +partes[1], b: +partes[2] };
  }

  luminancia({ r, g, b }) {
    const canal = (v) => {
      const n = v / 255;
      return n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
    };
    return (0.2126 * canal(r)) + (0.7152 * canal(g)) + (0.0722 * canal(b));
  }

  contraste(a, b) {
    const la = this.luminancia(a);
    const lb = this.luminancia(b);
    return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
  }
}
if (!customElements.get('vx-header')) customElements.define('vx-header', VXHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-hero"] && !Shopify.designMode) return;
  try {
    
class VXHero extends HTMLElement {
  connectedCallback() {
    this.escolherMidias();
    this.montarSlides();
    this.montarCarrinho();
  }

  /* Cada slide traz a midia de computador e a de celular. Aqui a
     que nao serve para esta tela e apagada, antes de carregar. */
  escolherMidias() {
    const estreito = window.matchMedia('(max-width: 749px)').matches;
    const desejado = estreito ? 'mobile' : 'desktop';

    this.querySelectorAll('[data-vx-slide]').forEach((slide) => {
      const midias = Array.from(slide.querySelectorAll('[data-vx-midia]'));
      if (midias.length < 2) return;

      const manter = midias.find((m) => m.dataset.tela === desejado) || midias[0];
      midias.forEach((m) => { if (m !== manter) m.remove(); });
    });
  }

  montarSlides() {
    this.slides = Array.from(this.querySelectorAll('[data-vx-slide]'));
    this.pontos = Array.from(this.querySelectorAll('[data-vx-ponto]'));
    this.atual = 0;

    this.tocarVideoDoSlide(this.slides[0]);

    if (this.slides.length < 2) return;

    this.pontos.forEach((ponto) => {
      ponto.addEventListener('click', () => {
        this.ir(parseInt(ponto.dataset.indice, 10));
        this.reiniciarRelogio();
      });
    });

    if (this.dataset.auto === 'true') this.reiniciarRelogio();

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) clearInterval(this.relogio);
      else if (this.dataset.auto === 'true') this.reiniciarRelogio();
    });
  }

  reiniciarRelogio() {
    clearInterval(this.relogio);
    const segundos = parseFloat(this.dataset.intervalo) || 6;
    this.relogio = setInterval(() => this.ir(this.atual + 1), segundos * 1000);
  }

  ir(indice) {
    const total = this.slides.length;
    this.atual = ((indice % total) + total) % total;

    this.slides.forEach((s, i) => {
      const ativo = i === this.atual;
      s.classList.toggle('esta-ativo', ativo);

      const video = s.querySelector('[data-vx-video]');
      if (!video) return;

      if (ativo) this.tocarVideoDoSlide(s);
      else video.pause();
    });

    this.pontos.forEach((p, i) => p.classList.toggle('esta-ativo', i === this.atual));
  }

  /* O video so carrega quando o slide dele entra em cena. */
  tocarVideoDoSlide(slide) {
    if (!slide) return;
    const video = slide.querySelector('[data-vx-video]');
    if (!video) return;

    if (video.preload === 'none') {
      video.preload = 'auto';
      video.load();
    }

    const tentativa = video.play();
    if (tentativa && typeof tentativa.catch === 'function') {
      tentativa.catch(() => { /* silencioso: o poster continua na tela */ });
    }
  }

  /* Cada slide pode ter seu card, entao sao varios formularios. */
  montarCarrinho() {
    this.querySelectorAll('form[data-vx-add]').forEach((form) => {
      form.addEventListener('submit', async (evento) => {
        evento.preventDefault();
        const dados = new FormData(form);

        try {
          const resposta = await fetch('/cart/add.js', { method: 'POST', body: dados });
          if (!resposta.ok) throw new Error('falhou');

          form.classList.add('is-adicionado');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
          setTimeout(() => form.classList.remove('is-adicionado'), 2200);
        } catch (erro) {
          form.submit();
        }
      });
    });
  }
}
if (!customElements.get('vx-hero')) customElements.define('vx-hero', VXHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-historia-linha"] && !Shopify.designMode) return;
  try {
    
class VXHistoriaLinha extends HTMLElement {
  connectedCallback() {
    this.palco = this.querySelector('[data-vx-palco]');
    this.pista = this.querySelector('[data-vx-pista]');
    if (!this.palco || !this.pista) return;

    this.reduzido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.estreito = window.matchMedia('(max-width: 749px)');
    this.visivel = false;
    this.rodando = false;

    this.medir = this.medir.bind(this);
    this.passo = this.passo.bind(this);

    this.medir();

    if ('IntersectionObserver' in window) {
      this.observador = new IntersectionObserver((entradas) => {
        entradas.forEach((entrada) => {
          this.visivel = entrada.isIntersecting;
          if (this.visivel) this.iniciar();
        });
      }, { rootMargin: '300px 0px' });
      this.observador.observe(this);
    } else {
      this.visivel = true;
      this.iniciar();
    }

    window.addEventListener('resize', this.medir, { passive: true });

    if (this.estreito.addEventListener) {
      this.estreito.addEventListener('change', this.medir);
    }

    this.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', this.medir, { once: true });
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(this.medir);
    }
  }

  disconnectedCallback() {
    this.visivel = false;
    if (this.quadro) cancelAnimationFrame(this.quadro);
    if (this.observador) this.observador.disconnect();
    window.removeEventListener('resize', this.medir);
    if (this.estreito && this.estreito.removeEventListener) {
      this.estreito.removeEventListener('change', this.medir);
    }
  }

  get horizontalAtivo() {
    if (this.reduzido) return false;
    if (this.estreito.matches && !this.classList.contains('vx-hl--mob-horizontal')) return false;
    return true;
  }

  igualarAlturaTexto() {
    const caixas = Array.from(this.querySelectorAll('.vx-hl__texto'));
    if (!caixas.length) return;

    const mobile = this.estreito.matches;
    const minimo = parseFloat(mobile ? this.dataset.altMobile : this.dataset.altDesktop) || 0;

    this.style.setProperty('--texto-altura-usada', '0px');

    let maior = 0;
    caixas.forEach((caixa) => {
      maior = Math.max(maior, caixa.getBoundingClientRect().height);
    });

    this.style.setProperty('--texto-altura-usada', Math.ceil(Math.max(minimo, maior)) + 'px');
  }

  medir() {
    this.igualarAlturaTexto();

    if (!this.horizontalAtivo) {
      this.classList.remove('esta-pronto');
      this.style.removeProperty('--altura-rolagem');
      this.palco.scrollLeft = 0;
      this.distancia = 0;
      return;
    }

    this.distancia = Math.max(0, this.palco.scrollWidth - this.palco.clientWidth);

    if (!this.distancia) {
      this.classList.remove('esta-pronto');
      this.style.removeProperty('--altura-rolagem');
      return;
    }

    const velocidade = parseFloat(this.dataset.velocidade) || 1;
    this.style.setProperty('--altura-rolagem', (this.distancia / velocidade) + 'px');
    this.classList.add('esta-pronto');

    this.distancia = Math.max(0, this.palco.scrollWidth - this.palco.clientWidth);
    this.ultimoAlvo = null;
    this.atualizar();
  }

  iniciar() {
    if (this.rodando) return;
    this.rodando = true;
    this.quadro = requestAnimationFrame(this.passo);
  }

  passo() {
    if (!this.visivel) { this.rodando = false; return; }
    this.atualizar();
    this.quadro = requestAnimationFrame(this.passo);
  }

  atualizar() {
    if (!this.horizontalAtivo || !this.distancia) return;

    const caixa = this.getBoundingClientRect();
    const percurso = this.offsetHeight - window.innerHeight;
    if (percurso <= 0) return;

    const bruto = -caixa.top / percurso;
    const progresso = Math.min(1, Math.max(0, bruto));
    const alvo = Math.round(progresso * this.distancia);

    if (alvo !== this.ultimoAlvo) {
      this.palco.scrollLeft = alvo;
      this.ultimoAlvo = alvo;
    }
  }
}
if (!customElements.get('vx-historia-linha')) customElements.define('vx-historia-linha', VXHistoriaLinha);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-pilha-produtos"] && !Shopify.designMode) return;
  try {
    
class VXPilha extends HTMLElement {
  connectedCallback() {
    this.coluna = this.querySelector('[data-vx-coluna]');
    this.palco = this.querySelector('[data-vx-palco]');
    this.faixas = Array.from(this.querySelectorAll('[data-vx-faixa]'));
    this.zonas = Array.from(this.querySelectorAll('[data-vx-zona]'));
    if (!this.coluna || !this.zonas.length) return;

    this.zonas.forEach((zona) => {
      zona.addEventListener('mouseenter', () => this.ativar(zona.dataset.indice));
      zona.addEventListener('focus', () => this.ativar(zona.dataset.indice));
    });

    this.palco.addEventListener('mouseleave', () => this.repousar());
    this.palco.addEventListener('focusout', (evento) => {
      if (!this.palco.contains(evento.relatedTarget)) this.repousar();
    });
  }

  ativar(indice) {
    this.coluna.classList.add('tem-ativo');
    this.faixas.forEach((faixa) => {
      faixa.classList.toggle('esta-ativo', faixa.dataset.indice === indice);
    });
  }

  repousar() {
    this.coluna.classList.remove('tem-ativo');
    this.faixas.forEach((faixa) => faixa.classList.remove('esta-ativo'));
  }
}
if (!customElements.get('vx-pilha')) customElements.define('vx-pilha', VXPilha);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-pilula-flutuante"] && !Shopify.designMode) return;
  try {
    
class VXPilulaFlutuante extends HTMLElement {
  connectedCallback() {
    this.alvo = document.querySelector(this.dataset.alvo || '.vx-pp');
    this.montarObservador();
    this.montarCarrinho();
  }

  disconnectedCallback() {
    if (this.observador) this.observador.disconnect();
  }

  /* Observa a secao principal do produto. Enquanto qualquer parte
     dela estiver visivel, a pilula fica escondida. Usar observador
     em vez de calcular posicao no scroll evita trabalho a cada
     rolagem e nao trava em telas de altura variavel. */
  montarObservador() {
    if (!this.alvo || !('IntersectionObserver' in window)) {
      this.classList.add('esta-visivel');
      return;
    }

    this.observador = new IntersectionObserver((entradas) => {
      entradas.forEach((entrada) => {
        this.classList.toggle('esta-visivel', !entrada.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });

    this.observador.observe(this.alvo);
  }

  montarCarrinho() {
    const form = this.querySelector('[data-vx-pf-form]');
    if (!form) return;

    form.addEventListener('submit', async (evento) => {
      evento.preventDefault();
      const rotulo = form.querySelector('[data-vx-pf-texto]');
      const original = rotulo ? rotulo.textContent : '';

      try {
        const resposta = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        if (!resposta.ok) throw new Error('falhou');

        if (rotulo) rotulo.textContent = 'Adicionado \u2713';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        setTimeout(() => { if (rotulo) rotulo.textContent = original; }, 2200);
      } catch (erro) {
        form.submit();
      }
    });
  }
}
if (!customElements.get('vx-pilula-flutuante')) customElements.define('vx-pilula-flutuante', VXPilulaFlutuante);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-primeiro-passo"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   AJUSTE DA 1a LINHA DA DIREITA

   Mede a largura do "40% OFF" e calcula o tamanho de letra que faz
   a 1a linha de baixo ("O MAIOR DESCONTO") ter exatamente a mesma
   largura. Refaz a conta quando a fonte termina de carregar, quando
   a janela muda de tamanho (computador x celular) e quando a secao
   e editada no editor do Shopify.

   Se o JavaScript nao rodar, a linha so fica no tamanho do controle
   "Tamanho das linhas de baixo" e nada quebra.
   ============================================================ */
class VXPassoAjuste extends HTMLElement {
  connectedCallback() {
    this.ajustar = this.ajustar.bind(this);
    this.ajustar();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.ajustar);
    const referencia = this.querySelector('[data-vx-referencia]');
    if (referencia && 'ResizeObserver' in window) {
      this.observador = new ResizeObserver(() => this.ajustar());
      this.observador.observe(referencia);
    }
    window.addEventListener('resize', this.ajustar);
  }

  disconnectedCallback() {
    if (this.observador) this.observador.disconnect();
    window.removeEventListener('resize', this.ajustar);
  }

  ajustar() {
    const referencia = this.querySelector('[data-vx-referencia]');
    const alvo = this.querySelector('[data-vx-esticar]');
    const acompanham = this.querySelectorAll('[data-vx-acompanha]');

    /* Volta tudo ao tamanho do controle antes de medir. */
    if (alvo) alvo.style.removeProperty('font-size');
    acompanham.forEach((linha) => linha.style.removeProperty('font-size'));
    if (!referencia || !alvo) return;

    /* No celular com "texto corrido" as linhas viram um paragrafo
       com letra normal, entao nao ha nada para esticar. */
    if (this.hasAttribute('data-corrido-mobile') && window.matchMedia('(max-width: 749px)').matches) return;

    const larguraReferencia = referencia.getBoundingClientRect().width;
    const larguraAlvo = alvo.getBoundingClientRect().width;
    if (!larguraReferencia || !larguraAlvo) return;

    const tamanhoAtual = parseFloat(getComputedStyle(alvo).fontSize);
    const tamanhoNovo = (tamanhoAtual * larguraReferencia / larguraAlvo).toFixed(2) + 'px';

    /* "important" para vencer o !important do estilo da secao. */
    alvo.style.setProperty('font-size', tamanhoNovo, 'important');
    if (this.hasAttribute('data-mesmo-tamanho')) {
      acompanham.forEach((linha) => linha.style.setProperty('font-size', tamanhoNovo, 'important'));
    }
  }
}
if (!customElements.get('vx-passo-ajuste')) customElements.define('vx-passo-ajuste', VXPassoAjuste);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-produto-destaque"] && !Shopify.designMode) return;
  try {
    
class VXProduto extends HTMLElement {
  connectedCallback() {
    this.montarGaleria();
    this.montarQuantidade();
    this.montarCarrinho();
  }

  montarGaleria() {
    const minis = Array.from(this.querySelectorAll('[data-vx-mini]'));
    const quadros = Array.from(this.querySelectorAll('[data-vx-quadro]'));
    if (!minis.length) return;

    minis.forEach((mini) => {
      mini.addEventListener('click', () => {
        const indice = mini.dataset.indice;
        minis.forEach((m) => m.classList.toggle('esta-ativo', m === mini));
        quadros.forEach((q) => q.classList.toggle('esta-ativo', q.dataset.indice === indice));
      });
    });
  }

  montarQuantidade() {
    const campo = this.querySelector('[data-vx-qtd]');
    const menos = this.querySelector('[data-vx-menos]');
    const mais = this.querySelector('[data-vx-mais]');
    if (!campo) return;

    if (menos) menos.addEventListener('click', () => {
      const atual = parseInt(campo.value, 10) || 1;
      campo.value = Math.max(1, atual - 1);
    });

    if (mais) mais.addEventListener('click', () => {
      const atual = parseInt(campo.value, 10) || 1;
      campo.value = atual + 1;
    });
  }

  montarCarrinho() {
    const form = this.querySelector('[data-vx-form]');
    if (!form) return;

    form.addEventListener('submit', async (evento) => {
      evento.preventDefault();
      const botao = form.querySelector('[data-vx-add]');
      const rotulo = form.querySelector('[data-vx-add-texto]');
      const original = rotulo ? rotulo.textContent : '';

      try {
        const resposta = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        if (!resposta.ok) throw new Error('falhou');

        if (rotulo) rotulo.textContent = 'Adicionado \u2713';
        if (botao) botao.classList.add('esta-feito');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));

        setTimeout(() => {
          if (rotulo) rotulo.textContent = original;
          if (botao) botao.classList.remove('esta-feito');
        }, 2200);
      } catch (erro) {
        form.submit();
      }
    });
  }
}
if (!customElements.get('vx-produto')) customElements.define('vx-produto', VXProduto);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-produto-faq"] && !Shopify.designMode) return;
  try {
    
class VXProdutoFaq extends HTMLElement {
  connectedCallback() {
    this.grupos = Array.from(this.querySelectorAll('[data-vx-grupo]'));
    this.numeros = Array.from(this.querySelectorAll('[data-vx-numero]'));
    if (this.grupos.length < 2) return;

    this.numeros.forEach((numero) => {
      numero.addEventListener('click', () => this.ir(parseInt(numero.dataset.indice, 10)));
    });
  }

  ir(indice) {
    this.grupos.forEach((grupo, i) => grupo.classList.toggle('esta-ativo', i === indice));
    this.numeros.forEach((numero, i) => numero.classList.toggle('esta-ativo', i === indice));
  }
}
if (!customElements.get('vx-produto-faq')) customElements.define('vx-produto-faq', VXProdutoFaq);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-produto-pagina"] && !Shopify.designMode) return;
  try {
    
class VXProdutoPagina extends HTMLElement {
  connectedCallback() {
    this.montarGaleria();
    this.montarQuantidade();
    this.montarCarrinho();
    this.montarFrete();
    this.montarAvaliacoes();
  }

  /* IR ATE AS AVALIACOES
     O widget do Judge.me fica numa secao mais abaixo (a secao
     "Secao" com o bloco Review Widget). O codigo procura esse
     widget na pagina e rola ate o topo da secao que o contem.
     Sao varios jeitos de achar porque o Judge.me pode desenhar o
     widget de formas diferentes. Se a pagina nao tiver widget, o
     clique nao faz nada, em vez de pular para o topo.
     scrollIntoView funciona tanto no computador (onde quem rola e
     a .page-wrapper) quanto no celular (onde rola a pagina). */
  montarAvaliacoes() {
    const link = this.querySelector('[data-vx-ir-avaliacoes]');
    if (!link) return;

    link.addEventListener('click', (evento) => {
      evento.preventDefault();

      const widget = document.querySelector(
        '[id*="judge_me_reviews_review_widget"], #judgeme_product_reviews, .jdgm-review-widget, .shopify-app-block[id*="review_widget"]'
      );
      if (!widget) return;

      const alvo = widget.closest('.shopify-section') || widget;

      /* Folga no topo para o cabecalho fixo nao cobrir o titulo
         das avaliacoes quando a rolagem terminar. */
      alvo.style.scrollMarginTop = 'calc(var(--vx-header-reserva, 110px) + 12px)';
      alvo.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  montarGaleria() {
    this.slides = Array.from(this.querySelectorAll('[data-vx-slide]'));
    this.pontos = Array.from(this.querySelectorAll('[data-vx-ponto]'));
    if (this.slides.length < 2) return;

    this.atual = 0;
    this.duracao = 420;
    this.arrasteDx = 0;
    this.vizinho = null;

    /* As setas informam o sentido (1 = avancar, -1 = voltar) para a
       foto sempre entrar pelo lado certo, mesmo quando da a volta
       da ultima para a primeira. */
    const proximo = this.querySelector('[data-vx-proximo]');
    if (proximo) proximo.addEventListener('click', () => this.ir(this.atual + 1, 1));

    const anterior = this.querySelector('[data-vx-anterior]');
    if (anterior) anterior.addEventListener('click', () => this.ir(this.atual - 1, -1));

    this.pontos.forEach((ponto) => {
      ponto.addEventListener('click', () => this.ir(parseInt(ponto.dataset.indice, 10)));
    });

    this.montarArraste();
  }

  /* O calculo com dois restos faz a volta funcionar nos dois
     sentidos: da primeira foto, voltar leva para a ultima.
     A foto nova entra pelo lado do sentido e a antiga sai pelo
     outro. Nas bolinhas o sentido vem da posicao: bolinha a
     direita da atual avanca, a esquerda volta. */
  ir(indice, sentido) {
    const total = this.slides.length;
    const novo = ((indice % total) + total) % total;
    if (novo === this.atual) { this.voltarAoLugar(); return; }

    const dir = sentido || (novo > this.atual ? 1 : -1);
    const velha = this.slides[this.atual];
    const nova = this.slides[novo];
    const dx = this.arrasteDx || 0;

    /* Cliques rapidos: esconde qualquer foto que ainda estava no
       meio de uma troca anterior. */
    this.slides.forEach((s) => { if (s !== velha && s !== nova) this.recolher(s); });

    /* A foto nova comeca encostada na atual, do lado de onde vem.
       Se a pessoa estava arrastando, ela ja esta nessa posicao e
       o movimento so continua de onde o dedo parou. */
    nova.style.transition = 'none';
    nova.style.visibility = 'visible';
    nova.style.transform = 'translateX(calc(' + (dir * 100) + '% + ' + dx + 'px))';
    velha.style.visibility = 'visible';
    void nova.offsetWidth; /* obriga o navegador a registrar a posicao inicial antes de animar */

    const animacao = 'transform ' + this.duracao + 'ms cubic-bezier(0.25, 0.8, 0.25, 1)';
    velha.style.transition = animacao;
    nova.style.transition = animacao;
    velha.style.transform = 'translateX(' + (-dir * 100) + '%)';
    nova.style.transform = 'translateX(0)';

    this.atual = novo;
    this.vizinho = null;
    this.slides.forEach((s, i) => s.classList.toggle('esta-ativo', i === this.atual));
    this.pontos.forEach((p, i) => p.classList.toggle('esta-ativo', i === this.atual));
    this.agendarLimpeza();
  }

  /* Esconde uma foto e apaga as posicoes que o codigo deu a ela,
     devolvendo o controle para o CSS. */
  recolher(slide) {
    slide.style.transition = 'none';
    slide.style.transform = '';
    slide.style.visibility = '';
  }

  /* Terminada a animacao, so a foto atual continua visivel. */
  agendarLimpeza() {
    clearTimeout(this.timerLimpeza);
    this.timerLimpeza = setTimeout(() => {
      this.slides.forEach((s, i) => { if (i !== this.atual) this.recolher(s); });
    }, this.duracao + 60);
  }

  /* Arraste curto demais: a foto atual volta para o centro e a
     vizinha volta para fora da tela. */
  voltarAoLugar() {
    const animacao = 'transform ' + this.duracao + 'ms cubic-bezier(0.25, 0.8, 0.25, 1)';
    const atual = this.slides[this.atual];
    atual.style.transition = animacao;
    atual.style.transform = 'translateX(0)';
    if (this.vizinho && this.vizinho !== atual) {
      const dir = this.arrasteDx < 0 ? 1 : -1;
      this.vizinho.style.transition = animacao;
      this.vizinho.style.transform = 'translateX(' + (dir * 100) + '%)';
    }
    this.vizinho = null;
    this.agendarLimpeza();
  }

  /* Durante o arraste a foto atual acompanha o dedo e a vizinha
     entra pelo lado para onde a pessoa esta puxando: puxar para a
     esquerda traz a proxima, para a direita traz a anterior. */
  arrastar(dx) {
    this.arrasteDx = dx;
    const total = this.slides.length;
    const atual = this.slides[this.atual];
    const dir = dx < 0 ? 1 : -1;
    const vizinho = this.slides[(((this.atual + dir) % total) + total) % total];

    /* Se a pessoa mudou de lado no meio do arraste, a vizinha
       anterior sai de cena. */
    if (this.vizinho && this.vizinho !== vizinho && this.vizinho !== atual) this.recolher(this.vizinho);
    this.vizinho = vizinho;

    atual.style.transition = 'none';
    atual.style.transform = 'translateX(' + dx + 'px)';
    vizinho.style.transition = 'none';
    vizinho.style.visibility = 'visible';
    vizinho.style.transform = 'translateX(calc(' + (dir * 100) + '% + ' + dx + 'px))';
  }

  /* ARRASTE COM DEDO E MOUSE
     "Pointer" cobre dedo, mouse e caneta com o mesmo codigo.
     Os primeiros 8px decidem a intencao: se o movimento e mais
     vertical, a pessoa quer rolar a pagina e o arraste nem comeca.
     Soltar depois de passar 20% da largura, ou num gesto rapido,
     troca a foto; antes disso, ela volta ao lugar. */
  montarArraste() {
    const palco = this.querySelector('.vx-pp__palco');
    if (!palco) return;
    palco.setAttribute('data-arrastavel', '');
    palco.addEventListener('dragstart', (e) => e.preventDefault());

    let id = null;
    let estado = 'parado';
    let inicioX = 0;
    let inicioY = 0;
    let inicioT = 0;

    palco.addEventListener('pointerdown', (e) => {
      /* Setas e bolinhas continuam funcionando como botoes. */
      if (e.button !== 0 || e.target.closest('button')) return;
      id = e.pointerId;
      estado = 'decidindo';
      inicioX = e.clientX;
      inicioY = e.clientY;
      inicioT = performance.now();
      this.arrasteDx = 0;
    });

    palco.addEventListener('pointermove', (e) => {
      if (e.pointerId !== id || estado === 'parado') return;
      const dx = e.clientX - inicioX;
      const dy = e.clientY - inicioY;

      if (estado === 'decidindo') {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        if (Math.abs(dy) > Math.abs(dx)) { estado = 'parado'; id = null; return; }
        estado = 'arrastando';
        /* Se uma troca ainda estava animando, encerra na hora para
           o dedo pegar a foto parada. */
        clearTimeout(this.timerLimpeza);
        this.slides.forEach((s, i) => {
          if (i !== this.atual) { this.recolher(s); return; }
          s.style.transition = 'none';
          s.style.transform = 'translateX(0)';
          s.style.visibility = 'visible';
        });
        this.vizinho = null;
        try { palco.setPointerCapture(id); } catch (erro) {}
        palco.classList.add('esta-arrastando');
      }

      e.preventDefault();
      this.arrastar(dx);
    });

    const soltar = (e) => {
      if (e.pointerId !== id) return;
      const estavaArrastando = estado === 'arrastando';
      estado = 'parado';
      id = null;
      palco.classList.remove('esta-arrastando');
      if (!estavaArrastando) return;

      const dx = this.arrasteDx;
      const largura = palco.offsetWidth || 1;
      const rapido = Math.abs(dx) > 30 && performance.now() - inicioT < 300;
      if (Math.abs(dx) > largura * 0.2 || rapido) {
        const dir = dx < 0 ? 1 : -1;
        this.ir(this.atual + dir, dir);
      } else {
        this.voltarAoLugar();
      }
      this.arrasteDx = 0;
    };
    palco.addEventListener('pointerup', soltar);
    palco.addEventListener('pointercancel', soltar);

    /* Trackpad do notebook: deslizar dois dedos para o lado troca a
       foto. Uma troca por gesto; a trava so solta quando o gesto
       termina (250ms sem movimento), senao o embalo do trackpad
       passaria varias fotos de uma vez. */
    let acumulado = 0;
    let travado = false;
    let timerRoda = null;
    palco.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      clearTimeout(timerRoda);
      timerRoda = setTimeout(() => { travado = false; acumulado = 0; }, 250);
      if (travado) return;
      acumulado += e.deltaX;
      if (Math.abs(acumulado) > 40) {
        const dir = acumulado > 0 ? 1 : -1;
        travado = true;
        acumulado = 0;
        this.arrasteDx = 0;
        this.ir(this.atual + dir, dir);
      }
    }, { passive: false });
  }

  montarQuantidade() {
    const campo = this.querySelector('[data-vx-qtd]');
    if (!campo) return;
    const menos = this.querySelector('[data-vx-menos]');
    const mais = this.querySelector('[data-vx-mais]');

    if (menos) menos.addEventListener('click', () => {
      campo.value = Math.max(1, (parseInt(campo.value, 10) || 1) - 1);
    });
    if (mais) mais.addEventListener('click', () => {
      campo.value = (parseInt(campo.value, 10) || 1) + 1;
    });
  }

  montarCarrinho() {
    const form = this.querySelector('[data-vx-form]');
    if (!form) return;

    const comprar = form.querySelector('[data-vx-comprar]');
    if (comprar) {
      comprar.addEventListener('click', () => { this.irParaCheckout = true; });
    }

    form.addEventListener('submit', async (evento) => {
      evento.preventDefault();
      const rotulo = form.querySelector('[data-vx-add-texto]');
      const original = rotulo ? rotulo.textContent : '';

      try {
        const resposta = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        if (!resposta.ok) throw new Error('falhou');

        if (this.irParaCheckout) { window.location.href = '/checkout'; return; }

        if (rotulo) rotulo.textContent = 'Adicionado ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        setTimeout(() => { if (rotulo) rotulo.textContent = original; }, 2200);
      } catch (erro) {
        form.submit();
      }
    });
  }

  montarFrete() {
    this.frete = this.querySelector('[data-vx-frete]');
    if (!this.frete) return;

    this.freteCep = this.frete.querySelector('[data-vx-frete-cep]');
    this.freteBtn = this.frete.querySelector('[data-vx-frete-calcular]');
    this.freteBtnTexto = this.frete.querySelector('[data-vx-frete-btn-texto]');
    this.freteCaixa = this.frete.querySelector('[data-vx-frete-resultado]');
    if (!this.freteCep || !this.freteBtn || !this.freteCaixa) return;

    this.freteCep.addEventListener('input', () => {
      const so = this.freteCep.value.replace(/\D/g, '').slice(0, 8);
      this.freteCep.value = so.length > 5 ? so.slice(0, 5) + '-' + so.slice(5) : so;
    });

    this.freteCep.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); this.calcularFrete(); }
    });

    this.freteBtn.addEventListener('click', () => this.calcularFrete());
  }

  mostrarAviso(mensagem) {
    this.freteCaixa.innerHTML = '<p class="vx-pp__frete-aviso"></p>';
    this.freteCaixa.querySelector('p').textContent = mensagem;
    this.freteCaixa.hidden = false;
  }

  async calcularFrete() {
    const cep = this.freteCep.value.replace(/\D/g, '');

    if (cep.length !== 8) {
      this.mostrarAviso('Digite um CEP com 8 numeros.');
      return;
    }

    const textoOriginal = this.freteBtnTexto ? this.freteBtnTexto.textContent : '';
    this.freteBtn.disabled = true;
    if (this.freteBtnTexto) this.freteBtnTexto.textContent = '...';
    this.mostrarAviso('Calculando...');

    let adicionado = false;
    const variante = this.frete.dataset.variante;

    try {
      const carrinho = await (await fetch('/cart.js')).json();

      if (carrinho.item_count === 0 && variante) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variante, quantity: 1 })
        });
        adicionado = true;
      }

      const url = '/cart/shipping_rates.json'
        + '?shipping_address%5Bzip%5D=' + encodeURIComponent(cep)
        + '&shipping_address%5Bcountry%5D=Brazil';

      const resposta = await fetch(url);
      if (!resposta.ok) throw new Error('consulta falhou');

      const dados = await resposta.json();
      const taxas = (dados && dados.shipping_rates) || [];

      if (!taxas.length) {
        this.mostrarAviso('Nao encontramos entrega para este CEP.');
        return;
      }

      this.desenharFrete(taxas);
    } catch (erro) {
      this.mostrarAviso('Nao foi possivel calcular agora. Tente de novo em instantes.');
    } finally {
      if (adicionado) {
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variante, quantity: 0 })
          });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (e) { /* silencioso */ }
      }

      this.freteBtn.disabled = false;
      if (this.freteBtnTexto) this.freteBtnTexto.textContent = textoOriginal;
    }
  }

  desenharFrete(taxas) {
    const moeda = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

    this.freteCaixa.innerHTML = '';

    taxas.forEach((taxa) => {
      const linha = document.createElement('div');
      linha.className = 'vx-pp__frete-item';

      const nome = document.createElement('span');
      nome.textContent = taxa.name || taxa.presentment_name || 'Entrega';

      const prazo = document.createElement('span');
      prazo.textContent = this.prazoDe(taxa);

      const valor = document.createElement('span');
      const numero = parseFloat(taxa.price);
      valor.textContent = numero === 0 ? 'Gratis' : moeda.format(numero);

      linha.append(nome, prazo, valor);
      this.freteCaixa.appendChild(linha);
    });

    this.freteCaixa.hidden = false;
  }

  prazoDe(taxa) {
    if (Array.isArray(taxa.delivery_days) && taxa.delivery_days.length) {
      const dias = taxa.delivery_days[taxa.delivery_days.length - 1];
      return dias + (dias === 1 ? ' dia' : ' dias');
    }

    if (Array.isArray(taxa.delivery_range) && taxa.delivery_range.length) {
      const fim = new Date(taxa.delivery_range[taxa.delivery_range.length - 1]);
      const dias = Math.max(1, Math.ceil((fim - new Date()) / 86400000));
      return dias + (dias === 1 ? ' dia' : ' dias');
    }

    const achado = String(taxa.name || '').match(/(\d+)\s*dia/i);
    if (achado) return achado[1] + ' dias';

    return '';
  }
}
if (!customElements.get('vx-produto-pagina')) customElements.define('vx-produto-pagina', VXProdutoPagina);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-reviews-video"] && !Shopify.designMode) return;
  try {
    
class VXReviewsPlayFix extends HTMLElement {
  connectedCallback() {
    this.pista = this.querySelector('[data-vx-pista]');
    if (!this.pista) return;

    this.itens = Array.from(this.pista.querySelectorAll('[data-vx-item]'));
    if (!this.itens.length) return;

    this.permitePrevia = this.dataset.hoverPreview === 'true';
    this.arrastando = false;
    this.arrastou = false;
    this.expandido = null;

    this.montarItens();
    this.montarArraste();
    this.atualizarCentralizacao();

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.atualizarCentralizacao(), 150);
    }, { passive: true });

    window.addEventListener('load', () => this.atualizarCentralizacao(), { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.pausarTodos();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.fecharExpandido();
    });

    this.addEventListener('click', (event) => {
      if (
        this.expandido &&
        this.classList.contains('vx-modal-ativo') &&
        !event.target.closest('.vx-reviews__moldura.vx-expandido')
      ) {
        this.fecharExpandido();
      }
    });
  }

  atualizarCentralizacao() {
    if (!this.pista || !this.itens.length) return;

    const gap = parseFloat(getComputedStyle(this.pista).gap || 0);
    const larguraItens = this.itens.reduce((total, item) => total + item.offsetWidth, 0);
    const larguraTotal = larguraItens + gap * Math.max(0, this.itens.length - 1);
    const larguraPista = this.pista.clientWidth;

    if (larguraTotal <= larguraPista) {
      const pad = Math.max(16, (larguraPista - larguraTotal) / 2);
      this.pista.classList.add('vx-sem-scroll');
      this.pista.style.setProperty('--vx-pad-inline', `${pad}px`);
    } else {
      this.pista.classList.remove('vx-sem-scroll');
      this.pista.style.removeProperty('--vx-pad-inline');
    }
  }

  existeVideoComAudioTocando() {
    return !!this.querySelector('.vx-reviews__moldura.esta-tocando');
  }

  pausarPreviewsExceto(atual) {
    this.querySelectorAll('video').forEach((video) => {
      if (video !== atual) {
        const moldura = video.closest('[data-vx-player]');
        if (moldura && moldura.classList.contains('esta-previa') && !moldura.classList.contains('esta-tocando')) {
          this.repousar(video);
        }
      }
    });
  }

  montarItens() {
    const aceitaHover = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    const reduzMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.itens.forEach((item) => {
      const moldura = item.querySelector('[data-vx-player]');
      const video = item.querySelector('video');
      const mainClick = item.querySelector('[data-vx-main-click]');
      const miniPlay = item.querySelector('[data-vx-mini-play]');
      const seek = item.querySelector('[data-vx-seek]');
      const tempo = item.querySelector('[data-vx-time]');
      const mute = item.querySelector('[data-vx-mute]');
      const volume = item.querySelector('[data-vx-volume]');
      const expand = item.querySelector('[data-vx-expand]');

      if (!video || !moldura) return;

      this.prepararVideo(video);

      video.addEventListener('loadedmetadata', () => this.atualizarTempo(video, seek, tempo));
      video.addEventListener('timeupdate', () => this.atualizarTempo(video, seek, tempo));

      video.addEventListener('volumechange', () => {
        moldura.classList.toggle('vx-mudo', video.muted || video.volume === 0);
        if (volume) volume.value = video.muted ? 0 : video.volume;
      });

      video.addEventListener('ended', () => this.repousar(video));

      if (this.permitePrevia && aceitaHover && !reduzMovimento) {
        item.addEventListener('mouseenter', () => {
          if (this.arrastando || this.arrastou) return;
          if (moldura.classList.contains('esta-tocando')) return;
          if (this.existeVideoComAudioTocando()) return;

          clearTimeout(item.vxTimerPrevia);

          item.vxTimerPrevia = setTimeout(() => {
            if (this.arrastando || this.arrastou) return;
            if (moldura.classList.contains('esta-tocando')) return;
            if (this.existeVideoComAudioTocando()) return;

            this.pausarPreviewsExceto(video);

            video.muted = true;
            video.defaultMuted = true;
            video.loop = true;
            video.controls = false;
            video.removeAttribute('controls');
            video.setAttribute('muted', '');
            video.preload = 'auto';

            moldura.classList.remove('esta-tocando');
            moldura.classList.add('esta-previa');

            this.mostrarVideoQuandoPronto(video, moldura);

            video.play().catch(() => {
              moldura.classList.remove('esta-previa', 'video-visivel');
            });
          }, 160);
        });

        item.addEventListener('mouseleave', () => {
          clearTimeout(item.vxTimerPrevia);

          if (!moldura.classList.contains('esta-tocando')) {
            this.repousar(video);
          }
        });
      }

      if (mainClick) {
        mainClick.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (this.arrastou) return;

          this.tocar(video, moldura);
        });
      }

      if (miniPlay) {
        miniPlay.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (video.paused) {
            this.tocar(video, moldura);
          } else {
            video.pause();
            moldura.classList.remove('esta-tocando');
          }
        });
      }

      if (seek) {
        seek.addEventListener('input', (event) => {
          event.stopPropagation();
          if (!video.duration) return;
          video.currentTime = (Number(seek.value) / 100) * video.duration;
        });

        seek.addEventListener('pointerdown', (event) => event.stopPropagation());
        seek.addEventListener('click', (event) => event.stopPropagation());
      }

      if (mute) {
        mute.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          video.muted = !video.muted;

          if (!video.muted && video.volume === 0) {
            video.volume = 1;
          }
        });
      }

      if (volume) {
        volume.addEventListener('input', (event) => {
          event.stopPropagation();

          video.volume = Number(volume.value);
          video.muted = video.volume === 0;
        });

        volume.addEventListener('pointerdown', (event) => event.stopPropagation());
        volume.addEventListener('click', (event) => event.stopPropagation());
      }

      if (expand) {
        expand.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (moldura.classList.contains('vx-expandido')) {
            this.fecharExpandido();
          } else {
            this.abrirExpandido(moldura);
          }
        });
      }
    });
  }

  prepararVideo(video) {
    try {
      video.pause();
      video.currentTime = 0;
    } catch (e) {}

    video.muted = true;
    video.defaultMuted = true;
    video.loop = false;
    video.controls = false;
    video.preload = 'none';

    video.removeAttribute('autoplay');
    video.removeAttribute('controls');
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('preload', 'none');
    video.setAttribute('disablepictureinpicture', '');
    video.setAttribute('controlslist', 'nodownload noplaybackrate nofullscreen');
  }

  mostrarVideoQuandoPronto(video, moldura) {
    const mostrar = () => {
      if (moldura.classList.contains('esta-tocando') || moldura.classList.contains('esta-previa')) {
        moldura.classList.add('video-visivel');
      }
    };

    if ('requestVideoFrameCallback' in video) {
      try {
        video.requestVideoFrameCallback(() => mostrar());
        return;
      } catch (e) {}
    }

    if (video.readyState >= 2) {
      setTimeout(mostrar, 80);
    } else {
      video.addEventListener('loadeddata', mostrar, { once: true });
      video.addEventListener('canplay', mostrar, { once: true });
      setTimeout(() => {
        if (video.readyState >= 2) mostrar();
      }, 700);
    }
  }

  tocar(video, moldura) {
    this.pausarOutros(video);

    const tempoAtual = video.currentTime || 0;

    try {
      video.pause();
    } catch (e) {}

    moldura.classList.remove('esta-previa', 'video-visivel');
    moldura.classList.add('esta-tocando');

    video.loop = false;
    video.muted = false;
    video.defaultMuted = false;
    video.volume = video.volume === 0 ? 1 : video.volume;
    video.controls = false;
    video.removeAttribute('controls');
    video.removeAttribute('muted');
    video.preload = 'auto';

    try {
      video.currentTime = tempoAtual;
    } catch (e) {}

    if (video.readyState < 2) {
      try {
        video.load();
      } catch (e) {}
    }

    this.mostrarVideoQuandoPronto(video, moldura);

    const tentativa = video.play();

    if (tentativa && typeof tentativa.catch === 'function') {
      tentativa.catch(() => {
        moldura.classList.remove('esta-tocando', 'video-visivel');

        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
      });
    }
  }

  repousar(video) {
    if (!video) return;

    try {
      video.pause();
      video.currentTime = 0;
    } catch (e) {}

    video.muted = true;
    video.defaultMuted = true;
    video.loop = false;
    video.controls = false;
    video.preload = 'none';
    video.removeAttribute('controls');
    video.setAttribute('muted', '');
    video.setAttribute('preload', 'none');

    const moldura = video.closest('[data-vx-player]');

    if (moldura) {
      moldura.classList.remove('esta-tocando', 'esta-previa', 'video-visivel');
      this.atualizarTempo(video, moldura.querySelector('[data-vx-seek]'), moldura.querySelector('[data-vx-time]'));
    }
  }

  atualizarTempo(video, seek, tempo) {
    const duracao = video.duration || 0;
    const atual = video.currentTime || 0;

    if (seek && duracao) {
      seek.value = String((atual / duracao) * 100);
    }

    if (tempo) {
      tempo.textContent = `${this.formatarTempo(atual)} / ${this.formatarTempo(duracao)}`;
    }
  }

  formatarTempo(segundos) {
    if (!Number.isFinite(segundos) || segundos < 0) segundos = 0;

    const min = Math.floor(segundos / 60);
    const sec = Math.floor(segundos % 60);

    return `${min}:${String(sec).padStart(2, '0')}`;
  }

  abrirExpandido(moldura) {
    if (this.expandido && this.expandido !== moldura) {
      this.fecharExpandido();
    }

    this.expandido = moldura;
    this.classList.add('vx-modal-ativo');
    document.documentElement.classList.add('vx-video-aberto');
    document.body.classList.add('vx-video-aberto');
    moldura.classList.add('vx-expandido');
  }

  fecharExpandido() {
    if (!this.expandido) return;

    this.expandido.classList.remove('vx-expandido');
    this.expandido = null;
    this.classList.remove('vx-modal-ativo');
    document.documentElement.classList.remove('vx-video-aberto');
    document.body.classList.remove('vx-video-aberto');
  }

  pausarOutros(atual) {
    this.querySelectorAll('video').forEach((video) => {
      if (video !== atual) this.repousar(video);
    });
  }

  pausarTodos() {
    this.querySelectorAll('video').forEach((video) => this.repousar(video));
    this.fecharExpandido();
  }

  montarArraste() {
    let pressionado = false;
    let inicioX = 0;
    let inicioY = 0;
    let ultimoX = 0;

    this.pista.addEventListener('pointerdown', (event) => {
      if (event.target.closest('[data-vx-main-click],[data-vx-controls]')) return;
      if (event.pointerType === 'touch') return;

      pressionado = true;
      this.arrastando = true;
      this.arrastou = false;

      inicioX = event.clientX;
      inicioY = event.clientY;
      ultimoX = event.clientX;

      this.pista.classList.add('esta-arrastando');

      try {
        this.pista.setPointerCapture(event.pointerId);
      } catch (e) {}
    });

    this.pista.addEventListener('pointermove', (event) => {
      if (!pressionado) return;

      const diffX = event.clientX - ultimoX;
      ultimoX = event.clientX;

      if (
        Math.abs(event.clientX - inicioX) > 6 ||
        Math.abs(event.clientY - inicioY) > 6
      ) {
        this.arrastou = true;
      }

      this.pista.scrollLeft -= diffX;
    });

    const soltar = (event) => {
      if (!pressionado) return;

      pressionado = false;
      this.arrastando = false;
      this.pista.classList.remove('esta-arrastando');

      try {
        this.pista.releasePointerCapture(event.pointerId);
      } catch (e) {}

      setTimeout(() => {
        this.arrastou = false;
      }, 120);
    };

    this.pista.addEventListener('pointerup', soltar);
    this.pista.addEventListener('pointerleave', soltar);
    this.pista.addEventListener('pointercancel', soltar);
    this.pista.addEventListener('dragstart', (event) => event.preventDefault());
  }
}

if (!customElements.get('vx-reviews-playfix')) {
  customElements.define('vx-reviews-playfix', VXReviewsPlayFix);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-ritual-upsell"] && !Shopify.designMode) return;
  try {
    
class VXRitualUpsell extends HTMLElement {
  connectedCallback() {
    this.encaixar();
    this.montarCarrossel('ritual', parseFloat(this.dataset.intervalo) || 0);
    this.montarCarrossel('info', parseFloat(this.dataset.intervaloInfo) || 0);
  }

  /* ============================================================
     ENCAIXE NA COLUNA DO PRODUTO

     A limpeza abaixo e obrigatoria no editor: quando voce mexe em
     um controle, a Shopify redesenha a secao no lugar original e
     cria uma copia nova. A que ja tinha se mudado continua na
     coluna, e apareciam duas caixas.
     ============================================================ */
  encaixar() {
    if (this.dataset.alvo !== 'true') return;

    const coluna = document.querySelector('.vx-pp__info');
    if (!coluna) return;

    document.querySelectorAll('vx-ritual-upsell').forEach((outro) => {
      if (outro !== this && outro.dataset.secao === this.dataset.secao) outro.remove();
    });

    if (this.parentElement === coluna) return;

    this.classList.add('esta-mudando');
    coluna.appendChild(this);
    requestAnimationFrame(() => this.classList.remove('esta-mudando'));
  }

  montarCarrossel(tipo, segundos) {
    const itens = Array.from(this.querySelectorAll('[data-vx-item="' + tipo + '"]'));
    const pontos = Array.from(this.querySelectorAll('[data-vx-ponto="' + tipo + '"]'));
    if (itens.length < 2) return;

    const estado = { atual: 0, relogio: null };

    const ir = (indice) => {
      const total = itens.length;
      estado.atual = ((indice % total) + total) % total;
      itens.forEach((el, i) => el.classList.toggle('esta-ativo', i === estado.atual));
      pontos.forEach((p, i) => p.classList.toggle('esta-ativo', i === estado.atual));
    };

    const reiniciar = () => {
      clearInterval(estado.relogio);
      if (segundos > 0) {
        estado.relogio = setInterval(() => ir(estado.atual + 1), segundos * 1000);
      }
    };

    pontos.forEach((ponto) => {
      ponto.addEventListener('click', () => {
        ir(parseInt(ponto.dataset.indice, 10));
        reiniciar();
      });
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) clearInterval(estado.relogio);
      else reiniciar();
    });

    reiniciar();
  }
}
if (!customElements.get('vx-ritual-upsell')) customElements.define('vx-ritual-upsell', VXRitualUpsell);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-upsell-informativo"] && !Shopify.designMode) return;
  try {
    
class VXUpsellInformativo extends HTMLElement {
  connectedCallback() {
    this.encaixar();
    this.carrosseis = {};
    this.montarCarrossel('card', parseFloat(this.dataset.intervalo) || 0);
    this.montarCarrossel('info', parseFloat(this.dataset.intervaloInfo) || 0);
    this.montarEditor();
  }

  /* ============================================================
     ENCAIXE NA COLUNA DO PRODUTO

     A limpeza abaixo e obrigatoria no editor: quando voce mexe em
     um controle, a Shopify redesenha a secao no lugar original e
     cria uma copia nova. A que ja tinha se mudado continua na
     coluna, e apareceriam duas caixas.
     ============================================================ */
  encaixar() {
    if (this.dataset.alvo !== 'true') return;

    const coluna = document.querySelector('.vx-pp__info');
    if (!coluna) return;

    document.querySelectorAll('vx-upsell-informativo').forEach((outro) => {
      if (outro !== this && outro.dataset.secao === this.dataset.secao) outro.remove();
    });

    if (this.parentElement === coluna) return;

    this.classList.add('esta-mudando');
    coluna.appendChild(this);
    requestAnimationFrame(() => this.classList.remove('esta-mudando'));
  }

  montarCarrossel(tipo, segundos) {
    const itens = Array.from(this.querySelectorAll('[data-vx-item="' + tipo + '"]'));
    const pontos = Array.from(this.querySelectorAll('[data-vx-ponto="' + tipo + '"]'));
    if (itens.length < 2) return;

    const estado = { atual: 0, relogio: null, parado: false };

    const ir = (indice) => {
      const total = itens.length;
      estado.atual = ((indice % total) + total) % total;
      itens.forEach((el, i) => el.classList.toggle('esta-ativo', i === estado.atual));
      pontos.forEach((p, i) => p.classList.toggle('esta-ativo', i === estado.atual));
    };

    const reiniciar = () => {
      clearInterval(estado.relogio);
      if (segundos > 0 && !estado.parado) {
        estado.relogio = setInterval(() => ir(estado.atual + 1), segundos * 1000);
      }
    };

    pontos.forEach((ponto) => {
      ponto.addEventListener('click', () => {
        ir(parseInt(ponto.dataset.indice, 10));
        reiniciar();
      });
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) clearInterval(estado.relogio);
      else reiniciar();
    });

    this.carrosseis[tipo] = { itens, ir, reiniciar, estado };
    reiniciar();
  }

  /* NO EDITOR DA SHOPIFY
     Ao clicar num card ou numa informacao na lateral do editor, o
     carrossel vai direto para ele e para de girar enquanto estiver
     selecionado — assim da para ver o texto que esta editando. */
  montarEditor() {
    if (!window.Shopify || !window.Shopify.designMode) return;

    const achar = (evento) => {
      for (const tipo of ['card', 'info']) {
        const c = this.carrosseis[tipo];
        if (!c) continue;
        const indice = c.itens.findIndex((el) => el === evento.target || el.contains(evento.target));
        if (indice > -1) return { c, indice };
      }
      return null;
    };

    document.addEventListener('shopify:block:select', (evento) => {
      const achado = achar(evento);
      if (!achado) return;
      achado.c.estado.parado = true;
      clearInterval(achado.c.estado.relogio);
      achado.c.ir(achado.indice);
    });

    document.addEventListener('shopify:block:deselect', (evento) => {
      const achado = achar(evento);
      if (!achado) return;
      achado.c.estado.parado = false;
      achado.c.reiniciar();
    });
  }
}
if (!customElements.get('vx-upsell-informativo')) customElements.define('vx-upsell-informativo', VXUpsellInformativo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-video-final"] && !Shopify.designMode) return;
  try {
    
/* Da o play so no video da tela atual e pausa o outro. Se a pessoa
   gira o tablet ou muda o tamanho da janela e a tela troca de
   tipo, troca o video junto. So age quando a secao tem os dois. */
class VXVideoFinalMidia extends HTMLElement {
  connectedCallback() {
    this.videoComputador = this.querySelector('.vx-video-final__versao--computador video');
    this.videoCelular = this.querySelector('.vx-video-final__versao--celular video');
    if (!this.videoComputador || !this.videoCelular) return;

    this.telaCelular = window.matchMedia('(max-width: 749px)');
    this.aoMudarTela = () => this.escolher();
    this.telaCelular.addEventListener('change', this.aoMudarTela);
    this.escolher();
  }

  disconnectedCallback() {
    if (this.telaCelular) this.telaCelular.removeEventListener('change', this.aoMudarTela);
  }

  escolher() {
    const celular = this.telaCelular.matches;
    const ativo = celular ? this.videoCelular : this.videoComputador;
    const parado = celular ? this.videoComputador : this.videoCelular;

    parado.pause();
    /* Navegadores so deixam dar play sozinho em video sem som. */
    ativo.muted = true;
    ativo.preload = 'auto';
    const tocando = ativo.play();
    if (tocando && tocando.catch) tocando.catch(() => {});
  }
}
if (!customElements.get('vx-video-final-midia')) customElements.define('vx-video-final-midia', VXVideoFinalMidia);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-video-newsletter"] && !Shopify.designMode) return;
  try {
    
/* Da o play so no video da tela atual e pausa o outro. Se a tela
   muda de tipo (tablet girado, janela redimensionada), troca junto.
   So age quando a secao tem os dois videos. */
class VXVideoNewsMidia extends HTMLElement {
  connectedCallback() {
    this.videoComputador = this.querySelector('.vx-vn__versao--computador video');
    this.videoCelular = this.querySelector('.vx-vn__versao--celular video');
    if (!this.videoComputador || !this.videoCelular) return;

    this.telaCelular = window.matchMedia('(max-width: 749px)');
    this.aoMudarTela = () => this.escolher();
    this.telaCelular.addEventListener('change', this.aoMudarTela);
    this.escolher();
  }

  disconnectedCallback() {
    if (this.telaCelular) this.telaCelular.removeEventListener('change', this.aoMudarTela);
  }

  escolher() {
    const celular = this.telaCelular.matches;
    const ativo = celular ? this.videoCelular : this.videoComputador;
    const parado = celular ? this.videoComputador : this.videoCelular;

    parado.pause();
    /* Navegadores so deixam dar play sozinho em video sem som. */
    ativo.muted = true;
    ativo.preload = 'auto';
    const tocando = ativo.play();
    if (tocando && tocando.catch) tocando.catch(() => {});
  }
}
if (!customElements.get('vx-vn-midia')) customElements.define('vx-vn-midia', VXVideoNewsMidia);

  } catch(e) { console.error(e); }
})();
})();
